import * as React from "react"

export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="81"
    fill="none"
    viewBox="0 0 80 81"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.386 68.444a2.34 2.34 0 0 1-2.097-1.218 2.3 2.3 0 0 1-.353-1.137q-.031-.632.348-1.267l29.657-51.13q.373-.593.9-.885.524-.292 1.16-.292.634 0 1.16.292t.898.885l29.658 51.13q.379.635.347 1.267t-.352 1.137a2.33 2.33 0 0 1-2.097 1.218h-59.23Zm2.383-3.782h54.462l-27.23-46.987zm27.484-5.006q.89 0 1.48-.603.588-.603.588-1.495t-.603-1.48q-.604-.59-1.496-.589c-.892.001-1.088.202-1.48.604q-.588.603-.588 1.495 0 .89.604 1.48.603.588 1.495.588m0-8.16q.812 0 1.343-.544.533-.543.533-1.348V35.233q0-.804-.549-1.348-.547-.543-1.359-.543-.81 0-1.342.543-.533.544-.533 1.348v14.371q0 .805.548 1.348.549.544 1.36.544Z"
    ></path>
  </svg>
)
